<section class="content">
  @if (showClose()) {
    <div class="icon-section">
      <pc-icon [icon]="xicon" [size]="iconSize" (clickIcon)="closeDisclaimer()"></pc-icon>
    </div>
  }
  <span [class]="spanClass()">{{ isAgentProcess() ? '' : translationText() }} {{ agentName() }}</span>
</section>
